import { render } from "./StaticRoutesTab.vue?vue&type=template&id=62b644f2&scoped=true"
import script from "./StaticRoutesTab.vue?vue&type=script&lang=js"
export * from "./StaticRoutesTab.vue?vue&type=script&lang=js"

import "./StaticRoutesTab.vue?vue&type=style&index=0&id=62b644f2&lang=scss&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b644f2"]])

export default __exports__